export default __webpack_public_path__ + "static/media/door-with-hanger-sign.8e463f82.png";